import React, { Component } from "react";
import { Input, Radio, Button, Select, Form, DatePicker } from "antd";
import { api, app } from "../../app";
import underscore from "underscore";
import PropTypes from "prop-types";
import locale from "antd/lib/date-picker/locale/zh_CN";

const RadioGroup = Radio.Group;
const Option = Select.Option;
const FormItem = Form.Item;

class PlayerAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posttionList: [],
      select_team: {},
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.PosttionData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.flush) {
      this.props.form.resetFields();
    }
  }

  /**
   * 设置值
   * @param data
   * @param cb
   */
  setData = (data, cb) => {
    if (this._isMounted) {
      this.setState(data, () => {
        if (cb) cb();
      });
    }
  };

  /**
   * 职务列表
   **/
  PosttionData = async () => {
    let { flag, data, msg } = await app.post(api.PosttionList);
    if (flag === 1) {
      const rights = app.getData("rights");
      let posttionList = data;
      if (rights === 1) {
        posttionList = underscore.map(data, (posttion) => {
          posttion.permiss = "";
          return posttion;
        });
      }
      this.setData({ posttionList });
    } else {
      app.alert(msg, "error");
    }
  };

  /**
   * 添加队员
   * @param e
   */
  handleAddPlayer = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.state.add_loading) return false;
        this.setData({ add_loading: true }, async () => {
          let params = {
              indexno: app.getData("indexno"),
              account: app.getData("account"),
            },
            { select_team } = this.props;
          values.team_position_id = values.team_position_id.join(",");
          values.teamno = select_team.teamno;
          values.indate = values.indate.format("YYYY-MM-DD");
          console.log(values);
          const { flag, msg } = await app.post(
            api.UserAdd,
            Object.assign(params, values)
          );
          if (flag === 1) {
            app.alert("添加成功", "success");
            this.props.form.resetFields();
            this.props.close(true);
          } else {
            app.alert(msg, "error");
          }
          this.setData({ add_loading: false });
        });
      }
    });
  };

  render() {
    const formItemLayout = {
        labelCol: { span: 7 },
        wrapperCol: { span: 10, offset: 1 },
      },
      { getFieldDecorator } = this.props.form,
      { posttionList, add_loading } = this.state;
    return (
      <Form style={{ width: "100%" }} onSubmit={this.handleAddPlayer}>
        <FormItem {...formItemLayout} label="姓名">
          {getFieldDecorator("name", {
            rules: [
              {
                required: true,
                message: "请填写队员名称！",
              },
            ],
          })(<Input size="large" placeholder="请填写队员名称" />)}
        </FormItem>
        <FormItem {...formItemLayout} label="身份">
          {getFieldDecorator("identity", {
            rules: [
              {
                required: true,
                message: "请选择队员身份！",
              },
            ],
          })(
            <Select size="large" placeholder="请选择队员身份">
              <Option value="1">队员</Option>
              {/*<Option value="2">预备队员</Option>*/}
              {/*<Option value="3">认证志愿者</Option>*/}
              {/*<Option value="6">志愿者</Option>*/}
            </Select>
          )}
          {/*<p style={{ color: "red", lineHeight: 2 }}>*/}
          {/*  【 志愿者 】身份不对外公开查询*/}
          {/*</p>*/}
          {/*<p style={{ color: "red", lineHeight: 2 }}>【志愿者】不设存心编号</p>*/}
        </FormItem>
        <FormItem {...formItemLayout} label="队内职务">
          {getFieldDecorator("team_position_id", {
            rules: [
              {
                required: true,
                message: "请选择队员队内职务！",
              },
            ],
          })(
            <Select
              size="large"
              mode="multiple"
              placeholder="请选择队员队内职务"
              notFoundContent="无"
              allowClear
            >
              {posttionList.map((posttion, index) => {
                return (
                  <Option
                    key={index + 1}
                    value={posttion.position_id}
                    disabled={posttion.permiss === "all"}
                  >
                    {posttion.position_name}
                  </Option>
                );
              })}
            </Select>
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="身份证号">
          {getFieldDecorator("idno", {
            rules: [
              { required: true, message: "请填写身份证号！" },
              // {pattern: /\d{17}[\d|x]|\d{15}/, message: '请填写正确的身份证号！'}
            ],
          })(<Input size="large" placeholder="请填写身份证号" max={18} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="手机号">
          {getFieldDecorator("mobile", {
            rules: [
              { required: true, message: "请填写队员手机号！" },
              // {len: 11, message: '请填写正确的手机号！'},
              // {pattern: /0?(13|14|15|16|17|18|19)[0-9]{9}/, message: '请填写正确的手机号！'},
            ],
          })(<Input size="large" placeholder="请填写队员手机号" />)}
        </FormItem>
        <FormItem {...formItemLayout} label="入队时间">
          {getFieldDecorator("indate", {
            rules: [{ required: true, message: "请选择入队时间！" }],
          })(
            <DatePicker
              size="large"
              placeholder="请选择入队时间"
              locale={locale}
            />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="性别">
          {getFieldDecorator("sex", { initialValue: "男" })(
            <RadioGroup
              size="large"
              options={[
                { label: "男", value: "男" },
                { label: "女", value: "女" },
              ]}
            />
          )}
        </FormItem>
        <div style={{ textAlign: "center" }}>
          <span
            className="ant-form-text"
            style={{ color: "red", display: "block", marginBottom: 16 }}
          >
            注：请先联系管理员设置队伍编码，队伍编码用于自动生成存心编号前缀。已设置可忽略~
          </span>
          <Button
            size="large"
            type="primary"
            htmlType="submit"
            loading={add_loading}
          >
            创建队员
          </Button>
        </div>
      </Form>
    );
  }
}

PlayerAdd.propTypes = {
  select_team: PropTypes.object.isRequired,
  flush: PropTypes.bool,
  close: PropTypes.func,
};

export default Form.create()(PlayerAdd);



// WEBPACK FOOTER //
// ./src/routes/ranks/PlayerAdd.jsx